module.exports = __webpack_public_path__ + "img/Golden-Mix-Oben.08fdf048.jpg";